import _ from 'lodash';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { ImageService } from 'app/core/services/image.service';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { EventService } from 'app/event/services/event.service';
import { filter, map, Observable, pairwise, Subject, switchMap, takeUntil } from 'rxjs';
import { loadCampaignList } from 'app/campaign/features/campaign.actions';
import { selectCampaignList } from 'app/campaign/features/campaign.selectors';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { ToastService } from 'app/toast/services/toast.service';
import { SamModalService } from 'app/event/services/sam-modal.service';
import { CampaignService } from 'app/campaign/services';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';


@Component({
  selector: 'app-simple-audiance-monitor-dialog',
  templateUrl: './simple-audiance-monitor-dialog.component.html',
  styleUrl: './simple-audiance-monitor-dialog.component.scss'
})
export class SimpleAudianceMonitorDialogComponent implements OnInit, AfterViewInit, OnDestroy{
  
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  public takeUntilSubject = new Subject();
  public event = null;
  public modalTitle = null;
  public activeScreen = 'monitorsList'
  public audianceMonitor: UntypedFormGroup = null;
  public monitorsList = null ;
  public monitorsActiveList = null ;
  public monitorsInActiveList = null ;
  public images = null;
  public selectedMonitor = null;
  public subtitle = 'Create or update Simple Audience Monitor.';
  
  public campaigns$ = this.store.pipe(
    select(selectCampaignList)
  );

  constructor(
    private store: Store,
    private dialogService: DialogService,
    private formBuilder: UntypedFormBuilder,
    public eventService:EventService,
    public imageService: ImageService,
    private domSanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService,
    private toastService: ToastService,
    private samModalService: SamModalService,
    private campaignService: CampaignService,
    private chooseImageModalService: ChooseImageModalService,
  ) { }

  ngOnInit(): void {
 
    this.getListOfMonitors();

    this.audianceMonitor = this.formBuilder.group({
      imageFile: null,
      imageUrl: '/images/blank_2x1.png',
      imageDataUrl: '/images/blank_2x1.png',
      name: '',
      goal: 0,
      // desc:'',
      // topBannerColor:'#000000',
      // topBannerTextColor:'#000000',
      goalProgessBackgroundColor:'#57e14e',
      goalProgessColor:'#ffffff',
      hideGoalProgress:false,
      campaignIds:[],
      startAt:0
    })

    const campaigns = this.audianceMonitor.get('campaignIds');

    campaigns.valueChanges.pipe(
      filter(list => {
          return list.length < 1 ? false: list[list.length - 1] === "all";
      }),
      switchMap(() => {
          return this.campaigns$;
      }),
      map(campaigns => {
          return campaigns.map(campaign => campaign.id);
      }),
      takeUntil(this.takeUntilSubject)
    ).subscribe((list) => {
        return campaigns.setValue(["all", ...list], { emitEvent: false });
    });


    campaigns.valueChanges.pipe(
    filter(list => list.length < 2 ? false: list[0] === "all"),
    takeUntil(this.takeUntilSubject)
    ).subscribe((list) => {
        return campaigns.setValue(list, { emitEvent: false });
    });

    campaigns.valueChanges.pipe(
    pairwise(),
    filter(([previousValue]) => {
        return previousValue.findIndex(element => element === "all") >= 0;
    }),
    filter(([,currentValue]) => {
        return currentValue.findIndex(element => element === "all") < 0;
    }),
    takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
        return campaigns.setValue([], { emitEvent: false });
    });

    this.audianceMonitor.get('campaignIds').valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((val)=>{
      this.audianceMonitor.get('campaignIds').setErrors(null);
    })

    this.audianceMonitor.get('imageFile').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      this.images = value;
      const windowURL = window.URL || window.webkitURL;
      if (value && value.length) {
        value.forEach(image => {
          const url = windowURL.createObjectURL(image);
          this.imageService.cropper({
            url: this.domSanitizer.bypassSecurityTrustUrl(url),
            id: 'audiance-monitor-image',
            name: image.name,
            type: image.type,
          });
        });
      } else {
        const url = windowURL.createObjectURL(value);
        this.imageService.cropper({
          url: this.domSanitizer.bypassSecurityTrustUrl(url),
          id: 'audiance-monitor-image',
          name: value.name,
          type: value.type,
        });
      }
    });
  
    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'audiance-monitor-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.audianceMonitor.get('imageDataUrl').setValue(result);
    });
  
    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'audiance-monitor-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImage();
      } else {
        this.audianceMonitor.get('imageUrl').setValue(result.imageUrl);
      }
  
      this.cdr.markForCheck();
    });

    this.store.dispatch({
      type: loadCampaignList.type,
      payload: this.sharedService.token
    });
  }

  getListOfMonitors(){
    let userHandle =  window['localOrgData'].user.handle
    let params = {handle:userHandle}
    this.eventService.getSimpleAudianceMonitorsAll(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((res:[])=>{
      if(res){
        this.monitorsList = res.sort((a:any, b:any) => b.updated - a.updated)
        this.monitorsActiveList = res.filter((mon:any)=>!mon.status).sort((a: any, b: any) => new Date(b.updated).getTime() - new Date(a.updated).getTime())
        this.monitorsInActiveList = res.filter((mon:any)=>mon.status).sort((a: any, b: any) => new Date(b.updated).getTime() - new Date(a.updated).getTime())
      } 
    })
  }

  resetImage() {
    this.audianceMonitor.get('imageFile').setValue(null);
    this.audianceMonitor.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.audianceMonitor.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  ngAfterViewInit(): void {

  }


  onCreateMonitor(){
    this.activeScreen = 'createMonitor'
    this.clearControls();
  }

  onClickCreateOrUpdate(type){
    this.audianceMonitor.markAllAsTouched()
    let newAudienceMonitor = this.audianceMonitor.value;

    newAudienceMonitor.imageUrl = newAudienceMonitor.imageUrl == '/images/blank_2x1.png' ? '' : newAudienceMonitor.imageUrl;

    if(newAudienceMonitor.campaignIds == null || newAudienceMonitor.campaignIds.length == 0){
        this.audianceMonitor.get('campaignIds').setErrors({'incorrect': true})
        return
    } 

    newAudienceMonitor.campaignIds = newAudienceMonitor.campaignIds.filter(item => item !== "all");

    if(type =='update'){
      this.subtitle = 'Update Simple Audience Monitor.'
      newAudienceMonitor.id = this.selectedMonitor.id;
      this.eventService.updateSimpleAudianceMonitor(newAudienceMonitor).subscribe(data=>{
        this.activeScreen = "monitorsList"
        this.clearControls()
        this.getListOfMonitors()
        this.toastService.showSuccess('Updated',{delay:2000});
      })
    }else if(type =='create'){
      this.subtitle = 'Update Simple Audience Monitor.'

      this.eventService.createSimpleAudianceMonitor(newAudienceMonitor).subscribe(data=>{
        this.activeScreen = "monitorsList"
        this.clearControls()
        this.getListOfMonitors()
        this.toastService.showSuccess('Created',{delay:2000});
      })
    }
  }

  editMonitor(monitor){
    this.activeScreen = 'updateMonitor'
    this.selectedMonitor = monitor;

    this.audianceMonitor.setValue({
      imageFile: null,
      imageUrl: monitor.imageUrl == '' ? '/images/blank_2x1.png' : monitor.imageUrl,
      imageDataUrl: monitor.imageUrl == '' ? '/images/blank_2x1.png' : monitor.imageUrl,
      name: monitor.name,
      goal: monitor.goal,
      // desc:monitor.desc,
      // topBannerColor:'#000000',
      // topBannerTextColor:'#000000',
      goalProgessBackgroundColor:monitor.goalProgessBackgroundColor,
      goalProgessColor:monitor.goalProgessColor,
      campaignIds:[...monitor.campaignIds],
      hideGoalProgress:monitor.hideGoalProgress,
      startAt:monitor.startAt
    });
  }

  onDeleteMonitorClick(monitor,activate=false){
    const resetAuctionDataAction = this.eventService.generateConfirmAction("confirmResetAuctionData", {
      text: activate ?  "This action will activate this Audience Monitor" : 'This action will deactivate this Audience Monitor',
      callback: (result) => {
        if(result) {
            this.eventService.deleteSimpleAudianceMonitor(monitor.id, activate).subscribe(data=>{
              this.getListOfMonitors();
            })
        }
      }
    });

    this.store.dispatch(resetAuctionDataAction);
  }


  openChooseImageModal() { // 0 for 2x1, 1 for 1x1
    const params = {
      start: 0,
      returnCount: 40,
      filterBy:[0]
    }

    this.campaignService.getOrganizationImages(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((imageList: any)=> {
      const list = imageList || [];
      const images = list.filter((image) => image.type === 0)
      const modalRef = this.chooseImageModalService.open({ images, type:0 });
    
      modalRef.onClose.pipe(
        takeUntil(this.takeUntilSubject)
      ).subscribe((imageUrl) =>{
        if(imageUrl) {
          this.audianceMonitor.get('imageDataUrl').setValue(imageUrl);
          this.audianceMonitor.get('imageUrl').setValue(imageUrl);
        }
        this.chooseImageModalService.modalRef = null;
      })
    })
  }

  clearControls(){
    this.audianceMonitor.reset({
      imageFile: null,
      imageUrl: '/images/blank_2x1.png',
      imageDataUrl: '/images/blank_2x1.png',
      name: '',
      goal: 0,
      // desc:'',
      // topBannerColor:'#000000',
      // topBannerTextColor:'#000000',
      goalProgessBackgroundColor:'#57e14e',
      goalProgessColor:'#ffffff',
      hideGoalProgress:false,
      campaignIds:[],
      startAt:0
    });
  }

  getImage(img){
    return img == '' ? '/images/org_logo_default_v2.svg' : img;
  }

  close() {
    this.samModalService.close();
  }

  getAmountDisplay(number){
    return window['utils'].getAmountDisplay(number)
  }

  ngOnDestroy(): void {
  this.takeUntilSubject.next(null);
  this.takeUntilSubject.complete();
  }
}
